import React from 'react';
// import classnames from 'classnames';
import { Button, Modal } from 'tea-component';
import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import LinkJump from '@gp/components/LinkJump';
import { queryJumpable } from '@gp/utils/common';
import { getProjectDetailsPagePath, goToProjectDetailsPageByPath } from '@gp/utils/project';

import type { ModalListItemType } from '../../types';

import './index.scss';

interface INumberModalProps {
  title: string;
  data: ModalListItemType[];
  visible: boolean;
  close: () => void;
}

const NumberModal: React.FC<INumberModalProps> = (props) => {
  const { title, data, visible, close } = props;

  return (
    <Modal className="dbg-number-modal" size={600} caption={title || '-'} visible={visible} onClose={close}>
      <Modal.Body>
        <div className="dbg-number-modal-context">
          {data?.map((item, index) => {
            const {
              id: itemId,
              title: itemTitle,
              img: itemImg,
              // status: itemStatus,
              // statusText: itemStatusText,
            } = item || {};
            const url = getProjectDetailsPagePath({
              id: itemId || '',
              name: itemTitle || '',
              tab: 'projectUpdate',
            });
            return (
              <div className="dbg-number-modal-item" key={index}>
                <div
                  className="dbg-number-modal-img"
                  onClick={(e) => {
                    if (!queryJumpable(e)) return;
                    goToProjectDetailsPageByPath(url);
                  }}
                >
                  <GeneralImageNew width={54} height={54} src={itemImg || ''} />
                </div>
                <LinkJump url={url}>
                  <div
                    onClick={(e) => {
                      if (!queryJumpable(e)) return;
                      goToProjectDetailsPageByPath(url);
                    }}
                  >
                    <EllipsisTextBubble
                      key={String(visible)}
                      text={itemTitle || '-'}
                      ellipsisLineClamp={2}
                      className="dbg-number-modal-text"
                    />
                    {/* <div*/}
                    {/*  className={classnames('', {*/}
                    {/*    'dbg-number-modal-risk': itemStatus === '1',*/}
                    {/*    'dbg-number-modal-hold': itemStatus === '2',*/}
                    {/*    'dbg-number-modal-nostarted': itemStatus !== '1' && itemStatus !== '2',*/}
                    {/*  })}*/}
                    {/* >*/}
                    {/*  {itemStatusText}*/}
                    {/* </div>*/}
                  </div>
                </LinkJump>
              </div>
            );
          })}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button type="weak" onClick={close}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(NumberModal);
